import { ValidateOfferResponseType } from "@entities/cart/types"

import { privateFetch, publicFetch } from "../libs/axios"
import {
  AddNoteRequestType,
  AddNoteResponseType,
  CancelBookingRequestType,
  CancelMembershipRequestType,
  CustomerRebookRequestType,
  DeleteNoteResponseType,
  EditNoteResponseType,
  GetAllNotesRequestType,
  GetAllNotesResponseType,
} from "../types/ViewOrderTypes"
import { jsonToQueryString } from "../utils/Common"

export const getAllNotes = async ({ notable_type, notable_id }: GetAllNotesRequestType) =>
  await privateFetch().get<GetAllNotesResponseType[]>(
    `/api/v1/notes${jsonToQueryString({
      "filter[notable_type]": notable_type,
      "filter[notable_id]": notable_id,
    })}`
  )

export const addNote = async (body: AddNoteRequestType) =>
  await privateFetch().post<AddNoteResponseType>("/api/v1/notes", body)

export const deleteNote = async (noteId: string) =>
  await privateFetch().delete<DeleteNoteResponseType>(`/api/v1/notes/${noteId}`)

export const editNote = async (noteId: string, content: string) =>
  await privateFetch().put<EditNoteResponseType>(`/api/v1/notes/${noteId}`, {
    content,
  })

export const cancelMembership = async (body: CancelMembershipRequestType) =>
  await privateFetch().post("/api/v1/customer-membership/cancel", body)

export const cancelBooking = async (
  bookingId: string,
  body: CancelBookingRequestType,
  isIntegratedPage?: boolean
) => {
  if (isIntegratedPage) {
    return await publicFetch().post(`/api/v1/public/booking/${bookingId}/cancel`, body)
  }
  return await privateFetch().post(`/api/v1/booking/${bookingId}/cancel`, body)
}

export const customerRebook = async (
  orderId: string,
  orderItemId: string,
  body: CustomerRebookRequestType
) =>
  await publicFetch().post(
    `/api/v1/public/order/${orderId}/order-item/${orderItemId}/update-slot`,
    body
  )

export const validateOffer = async (
  orderId: string,
  orderItemId: string,
  body: CustomerRebookRequestType
) =>
  await publicFetch().post<ValidateOfferResponseType>(
    `/api/v1/public/order/${orderId}/order-item/${orderItemId}/validate-offer`,
    body
  )
